export const promote = (config) => ({
    ...config,
    timeDelayValue: String(config.timeDelayValue)
});
//# sourceMappingURL=flow-control-delay-1-to-2.js.map